import Cookies from 'js-cookie';

class PreviousPage {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="PreviousPage"]'),
      backTarget: () =>
        document.querySelector('.js-backlink-container:nth-last-child(2) .js-backlink-origin'),
      hideWhenCookieEmpty: false
    };
  }

  init() {
    const { moduleList, backTarget, hideWhenCookieEmpty } = this.config;

    // Check if cookie previousPages exist if not create array with first item current url and add to cookie with expiration date in 1 hour
    if (!Cookies.get('png_previous_pages')) {
      Cookies.set('png_previous_pages', [window.location.href], { expires: 1 / 24 });
    } // check if current url is already in cookie if not add to cookie
    else {
      const urlList = JSON.parse(Cookies.get('png_previous_pages'));
      const filteredUrlList = urlList.filter(url => url === window.location.href);

      if (filteredUrlList.length === 0) {
        Cookies.set('png_previous_pages', [...urlList, window.location.href], { expires: 1 / 24 });
      }
    }

    moduleList().forEach(_module => {
      const module = _module;
      const { initialized } = module.dataset;

      if (initialized) return;

      module.dataset.initialized = true;

      if (
        hideWhenCookieEmpty &&
        (!Cookies.get('png_previous_pages') ||
          JSON.parse(Cookies.get('png_previous_pages')).length === 1)
      )
        module.style.display = 'none';

      // add click eventlistener to the module to go to the last url in the cookie and remove the current url from the cookie
      module.addEventListener('click', () => {
        const previousPages = JSON.parse(Cookies.get('png_previous_pages')) || [];
        const lastPage =
          previousPages[previousPages.length - 2] || backTarget().getAttribute('href');

        Cookies.set('png_previous_pages', previousPages.slice(0, previousPages.length - 2));
        window.location = lastPage;
      });
    });
  }
}

export default PreviousPage;
